import { cn } from '../utils/cn';

export const buttonVariants = {
  base: 'inline-flex items-center justify-center font-medium rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed',
  primary: 'bg-blue-600 text-white shadow-sm hover:bg-blue-700 focus:ring-blue-500',
  secondary: 'bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 focus:ring-gray-500',
  ghost: 'bg-transparent text-gray-700 hover:bg-gray-100 focus:ring-gray-500',
  danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500',
  success: 'bg-green-600 text-white hover:bg-green-700 focus:ring-green-500',
  warning: 'bg-amber-600 text-white hover:bg-amber-700 focus:ring-amber-500',
  outline: 'border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:ring-gray-500',
  destructive: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500',
} as const;

export const buttonSizes = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-2 text-sm',
  lg: 'px-6 py-3 text-base',
} as const;

export const inputVariants = {
  base: 'block w-full px-3 py-2.5 text-sm border border-gray-300 rounded-xl bg-white placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors',
  error: 'border-red-300 focus:ring-red-500 focus:border-red-500',
  disabled: 'bg-gray-50 cursor-not-allowed',
} as const;

export const cardVariants = {
  base: 'bg-white rounded-xl border border-gray-200',
  padding: { none: '', sm: 'p-4', md: 'p-6', lg: 'p-8' },
  shadow: { none: '', sm: 'shadow-sm', md: 'shadow-md', lg: 'shadow-lg' },
} as const;

export function buttonClass(
  variant: keyof typeof buttonVariants = 'primary',
  size: keyof typeof buttonSizes = 'md',
  className?: string
) {
  if (variant === 'base') return cn(buttonVariants.base, buttonSizes[size], className);
  return cn(buttonVariants.base, buttonVariants[variant], buttonSizes[size], className);
}

export function inputClass(options?: { error?: boolean; disabled?: boolean; icon?: boolean; className?: string }) {
  return cn(
    inputVariants.base,
    options?.error && inputVariants.error,
    options?.disabled && inputVariants.disabled,
    options?.icon && 'pl-10',
    options?.className
  );
}
